import { cva } from 'class-variance-authority';
import { ElementIntent } from '../../enums';
export const buttonStyling = cva([
    'flex items-center justify-center gap-stack-dense text-nowrap h-fit font-normal disabled:cursor-not-allowed group',
    'transition-colors rounded-pill',
], {
    variants: {
        variant: {
            primary: 'bg-fg text-fg-inverse hover:bg-brand-hover',
            secondary: 'bg-surface border border-border text-fg-muted hover:bg-fg hover:text-fg-inverse hover:border-fg',
            ghost: 'bg-transparent text-fg-muted hover:bg-bg-subtle',
            text: 'bg-transparent text-fg hover:underline',
        },
        intent: {
            [ElementIntent.Info]: '',
            [ElementIntent.Success]: '',
            [ElementIntent.Warning]: '',
            [ElementIntent.Danger]: '',
        },
        size: {
            sm: 'text-xs py-stack-tight px-stack',
            md: 'text-body-sm py-stack-tight px-stack',
            lg: 'text-body-sm py-stack px-stack-roomy',
        },
        withIcon: {
            true: '',
            false: '',
        },
        withChildren: {
            true: '',
            false: '',
        },
        isDisabled: {
            true: 'cursor-not-allowed',
            false: '',
        },
    },
    compoundVariants: [
        { withIcon: true, withChildren: false, className: 'gap-stack-dense' },
        { withIcon: false, withChildren: true, className: 'gap-stack-tight' },
        { withIcon: true, withChildren: true, className: 'gap-stack-tight' },
        // Primary intent variants
        { variant: 'primary', intent: ElementIntent.Info, className: 'bg-info hover:bg-info-hover text-fg-inverse' },
        { variant: 'primary', intent: ElementIntent.Success, className: 'bg-success hover:bg-success-hover text-fg-inverse' },
        { variant: 'primary', intent: ElementIntent.Warning, className: 'bg-warning hover:bg-warning-hover text-fg-inverse' },
        { variant: 'primary', intent: ElementIntent.Danger, className: 'bg-danger hover:bg-danger-hover text-fg-inverse' },
        // Secondary intent variants
        { variant: 'secondary', intent: ElementIntent.Info, className: 'border-info text-info-fg hover:bg-info-subtle' },
        { variant: 'secondary', intent: ElementIntent.Success, className: 'border-success text-success-fg hover:bg-success-subtle' },
        { variant: 'secondary', intent: ElementIntent.Warning, className: 'border-warning text-warning-fg hover:bg-warning-subtle' },
        { variant: 'secondary', intent: ElementIntent.Danger, className: 'border-danger text-danger-fg hover:bg-danger-subtle' },
        // Ghost intent variants
        { variant: 'ghost', intent: ElementIntent.Info, className: 'text-info-fg hover:bg-info-subtle' },
        { variant: 'ghost', intent: ElementIntent.Success, className: 'text-success-fg hover:bg-success-subtle' },
        { variant: 'ghost', intent: ElementIntent.Warning, className: 'text-warning-fg hover:bg-warning-subtle' },
        { variant: 'ghost', intent: ElementIntent.Danger, className: 'text-danger-fg hover:bg-danger-subtle' },
        // Text intent variants
        { variant: 'text', intent: ElementIntent.Info, className: 'text-info-fg' },
        { variant: 'text', intent: ElementIntent.Success, className: 'text-success-fg' },
        { variant: 'text', intent: ElementIntent.Warning, className: 'text-warning-fg' },
        { variant: 'text', intent: ElementIntent.Danger, className: 'text-danger-fg' },
    ],
    defaultVariants: {
        variant: 'primary',
        size: 'md',
    },
});
export const iconStyling = cva('', {
    variants: {
        size: {
            sm: 'size-3.5',
            md: 'size-4',
            lg: 'size-5',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
